import { gql } from '@apollo/client';

export const DELETE_POST_MUTATION = gql`
  mutation RemovePost($id: Int!) {
    removePost(id: $id) {
      id
    }
  }
`;